import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MaterialModule } from './material.module';
import { ToastrModule } from 'ngx-toastr';
import { ModalComponent } from './modal/modal.component';
import { MatDatepickerModule, MatNativeDateModule, MatInputModule } from '@angular/material';
import { ModaldeleteComponent } from './features/admin/main/qform/formlist/modaldelete/modaldelete.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { AlertModalComponent } from './features/form/alert-modal/alert-modal.component';
import { AuthGuardService } from './app.auth.service';
import { RefModalComponent } from './features/form/ref-modal/ref-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    ModalComponent,
    AlertModalComponent,
    ModaldeleteComponent,
    RefModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    MatDatepickerModule,        // <----- import(must)
    MatNativeDateModule,        // <----- import for date formating(optional)
    FormsModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    ToastrModule.forRoot() // ToastrModule added
  ],
  providers: [
    AuthGuardService,
    { provide: LocationStrategy, useClass: HashLocationStrategy, },
  ],
  entryComponents: [ModalComponent, AlertModalComponent, RefModalComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
